import request from '@/utils/request'

export function getWorkShiftInfoApi() {
  return request({
    url: '/cashier-service/v1/room-transaction/close-shift-info',
    method: 'get'
  })
}

export function uploadCashReport(data = {}) {
  return request({
    url: '/config-ticket-service/v1/ticket-shift-confirmation/cash-report',
    method: 'post',
    data
  })
}

export function uploadAdjustRecord(data = {}) {
  return request({
    url: '/config-ticket-service/v1/ticket-shift-confirmation/adjusted-record',
    method: 'post',
    data
  })
}

export function uploadRefundRequest(data = {}) {
  return request({
    url: '/config-ticket-service/v1/ticket-shift-confirmation/refund-request',
    method: 'post',
    data
  })
}

export function closeShiftwork(data = {}) {
  return request({
    url: '/config-ticket-service/v1/ticket-shift-confirmation/confirm',
    method: 'post',
    data
  })
}
